// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1impD","desktop":"styles_desktop__mTmG5","swiperContainer":"styles_swiperContainer__3MLGj"};